export default __webpack_public_path__ + "static/media/crm-feature-bg2.6d4f24da.svg";